import axios from 'redaxios';
export const setupRedaxiosClient = (apiHost, token, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_context) => {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    const axiosInstance = axios.create({
        baseURL: apiHost,
        headers,
    });
    return axiosInstance;
};
